import Button from '@/components/basicComponents/button';
import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import guid from '@/shared/utils/guid';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { InvestorEntitiesRowStatus } from '../../../investorEntitiesRowStatus';
import { IHouseholdComparison, TypeWindow } from '../../../types';
import { columns } from '../constants';

interface TableBodyProps {
  tableData: IHouseholdComparison[];
  openInvestorImportDetailPage: (type: TypeWindow, row: IHouseholdComparison) => void;
}

const TableBody = ({ tableData, openInvestorImportDetailPage }: TableBodyProps) => {
  if (!tableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {tableData.map((row) => (
        <CustomTableRowWrapper key={guid()}>
          <TableRowCell width={columns[0].width}>
            <TextCell>{row.householdName}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <TextCell>{row.totalEntities}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            <TextCell>
              <TextCell>{row.entitiesAdded}</TextCell>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>{row.entitiesRemoved}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            {row.advisorEmail?.toLowerCase() === 'multiple' ? <MultipleText>Multiple</MultipleText> : <TextCell>{row.advisorEmail}</TextCell>}
          </TableRowCell>
          <TableRowCell width={columns[5].width}>
            <TextCell>
              <InvestorEntitiesRowStatus status={row.status} />
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[6].width}>
            <ButtonWrap id="infoWrap">
              <Button size="sm" onClick={() => openInvestorImportDetailPage('investorImportDetail', row)}>
                View
              </Button>
            </ButtonWrap>
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
`;

const ButtonWrap = styled.div`
  opacity: 0;
`;

const MultipleText = styled(TextCell)`
  color: ${themeVar('context.error')};
`;
